<template>
        <div class="bg-wrap" :style="{height: bodyHeight + 'px'}">
             <div class="content-wrap">
                    <div>
                        <input type="text" placeholder="请输入姓名" style="text-indent: 15px" v-model="name">
                        <input type="text" readonly v-model="login" style="text-align: center;color: #0a4179;font-weight: bold" @click="toIndex">
                    </div>
             </div>
        </div>
</template>

<script>
    import {answerPlayerLogin} from "@/assets/js/api";

    export default {
        data(){
            return{
                login:"登录",
                name:"",
                bodyHeight:""
            }
        },
        methods:{
             toIndex(){
                console.log("----登录验证----")
                this.playerLogin(this.name)
            },
            async playerLogin(name){
                const res =  await answerPlayerLogin({name})
                console.log(res)
                if(res.data.code==200){
                    // console.log(res.data.data.playerId,"playerId=")
                    this.$store.state.playerId = res.data.data.playerId
                    this.$router.push({path:"qplayerquestion"})
                }else{
                    this.$toast(res.data.message)
                }
            }
        },
        mounted(){
            let playerId = this.$store.state.playerId;
            this.bodyHeight = document.documentElement.clientHeight
            console.log(playerId,"playerId")
            if(playerId!=""){
                this.$router.push({path:"qplayerquestion"})
            }
        }
    }
</script>

<style scoped>
    .bg-wrap{
        width: 100%;
        max-width: 375px;
        /*height: 100vh;*/
        background: #FFF url("../../assets/img/qkds_bg.jpg") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .content-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
        padding-top: 300px;
    }
    .content-wrap >span{
        color: #FFF;
        font-size: 38px;
        font-weight: bold;
        font-style: italic;
        letter-spacing: 3px;
    }
    input{
        margin-top: 40px;
        width: 85%;
        height: 32px;
        border: none;
        outline: none;
        border-radius: 20px;
        font-size: 14px;
        background: #99b9c8;
    }
    input:first-child{
        margin-top: 40px;
    }
    input:last-child{
        margin-top: 20px;
    }

</style>